
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 10A4.5 4.5 0 002 14.5v3a.5.5 0 001 0v-3A3.5 3.5 0 016.5 11h5a3.5 3.5 0 013.5 3.5v3a.5.5 0 001 0v-3a4.5 4.5 0 00-4.5-4.5h-5zm10-5.5a.5.5 0 00-.5.5v1.5h-1.5a.5.5 0 000 1H16V9a.5.5 0 001 0V7.5h1.5a.5.5 0 000-1H17V5a.5.5 0 00-.5-.5zM9 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5z","fill":"#000"}})])
          )
        }
      }
    